import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import WorkplaceCalendar from '../../../../Components/Calendar/WorkplaceCalendar';
import useCalendar from '../../Hooks/useFilter';
import WorkplaceCalendarFilter, {
	WorkplaceCalendarWithFilterValues,
} from './WorkplaceCalendarFilter';
// @ts-ignore
import styles from './WorkplaceCalendarWithFilter.module.scss';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	workplaceId: string;
	patientId?: string;
	params?: any;
}

const WorkplaceCalendarWithFilter: React.FC<Props> = ({
	workplaceId,
	patientId,
	params,
}) => {
	const { userData } = useAppContext();
	const { setFilter, filter } = useCalendar({ defaultFilter: params?.filter });
	const [filterDefaultValues, setFilterDefaultValues] = useState<
		WorkplaceCalendarWithFilterValues | undefined
	>(params?.filter);
	const wrapperRef = useRef<any>();
	const filterRef = useRef<any>();
	const [calendarHeight, setCalendarHeight] = useState<string>('100%');

	const handleOnShowOnyMeChange = (state: boolean) => {
		setFilterDefaultValues(
			state
				? {
						doctorIds: [userData.id],
				  }
				: filter,
		);
	};

	const handleCalculateDimensions = () => {
		if (wrapperRef.current && filterRef.current) {
			const wrapperHeight = wrapperRef.current.clientHeight;
			const filterHeight = filterRef.current.clientHeight;
			setCalendarHeight(`${wrapperHeight - filterHeight}px`);
		}
	};

	useLayoutEffect(() => {
		setTimeout(() => {
			handleCalculateDimensions();
		}, 1000);
	}, []);

	useEffect(() => {
		// @ts-ignore
		window.addEventListener('resize', handleCalculateDimensions);
		return () => {
			// @ts-ignore
			window.removeEventListener('resize', handleCalculateDimensions);
		};
	}, []);

	return (
		<div className={styles.wrapper} ref={wrapperRef}>
			<div ref={filterRef}>
				<WorkplaceCalendarFilter
					onFilter={setFilter}
					defaultValues={filterDefaultValues}
				/>
			</div>
			<div style={{ height: calendarHeight, position: 'relative' }}>
				<WorkplaceCalendar
					workplaceId={workplaceId}
					filter={filter}
					params={params}
					patientId={patientId}
					onShowOnyMeChange={handleOnShowOnyMeChange}
				/>
			</div>
		</div>
	);
};

export default WorkplaceCalendarWithFilter;
